import React, { useState, Fragment, useEffect, useRef } from 'react';
import { useFormContext, Controller, ErrorMessage } from 'react-hook-form';
import { Grid, FormControl, TextField, MenuItem, Select, InputLabel } from '@material-ui/core';
import { useStyle } from './style';
import Loading from '../shared/Loading';
import { SECURITY_QUESTIONS } from './constants';
import errormesages from './errormessages';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';


export const EirSecurityQuestion = () => {
    const { errors, control } = useFormContext();
    const graphql = useApolloClient();
    const classes = useStyle();
    const [securityQuestionList, setSecurityQuestionList] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const { validation } = errormesages;
    const answerInputRef = useRef();
    const questionInputRef = useRef();

    const getSecurityQuestions = async () => {
        setIsLoading(true);
        try {
            const response = await graphql.query({
                query: ENDPOINT.GET_SECURITYQUESTIONS
            });

            if (response.data != null) {
                return response.data;
            }
            else {
                //set default values   
                return SECURITY_QUESTIONS;
            }
        }
        catch (err) {
            //set default values           
            return SECURITY_QUESTIONS;
        }
    }

    useEffect(() => {
        getSecurityQuestions().then(data => {
            setSecurityQuestionList(data.securityQuestions);
            setIsLoading(false);
        });

    }, []);
    return (
        <Fragment>
            <h4 >Security question</h4>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <FormControl variant="outlined" fullWidth size="small">
                        <InputLabel required>Security question</InputLabel>
                        <Controller
                            control={control}
                            name="securityQuestion"
                            id="securityQuestion"
                            error={Boolean(errors.securityQuestion)}
                            defaultValue=""
                            rules={{ required: { value: true, message: validation.securityQuestionRequired } }}
                            as={
                                <Select
                                    id="securityQuestion"
                                    label="Security question *"
                                    inputRef={questionInputRef}
                                >
                                    {!isLoading &&
                                        securityQuestionList.map((securityQuestion) => (
                                            <MenuItem key={securityQuestion.code} value={securityQuestion.code}>
                                                {securityQuestion.question}
                                            </MenuItem>
                                        ))}
                                    {isLoading && (
                                        <Loading />
                                    )}
                                </Select>
                            }
                            onFocus={() => {
                                questionInputRef.current.focus();
                            }}
                        />
                        <ErrorMessage errors={errors} name="securityQuestion">
                            {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                        </ErrorMessage>

                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Controller
                        as={<TextField inputRef={answerInputRef} />}
                        control={control}
                        fullWidth
                        id="securityAnswer"
                        name="securityAnswer"
                        label="Answer"
                        variant="outlined"
                        size="small"
                        required
                        error={Boolean(errors.securityAnswer)}
                        rules={{ required: { value: true, message: validation.securityAnswerRequired } }}
                        onFocus={() => {
                            answerInputRef.current.focus();
                        }}
                    />
                    <ErrorMessage errors={errors} name="securityAnswer">
                        {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                    </ErrorMessage>
                </Grid>
            </Grid>
        </Fragment>
    );
}
